import { Fleet } from "./Fleet";

export interface Staff {
    _id: string;
    organizationId?: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    userType: UserType | undefined;
    updatedAt?: string | undefined;
    createdAt?: string | undefined;
    deletedAt?: string | undefined;
    fleets: Fleet[] | string[];    
}

export enum UserType {
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    STAFF = 'STAFF'
}